// @flow

import styled from 'styled-components';
import { BOLD } from '../../../../helpers/fontWeight';
import type { Theme } from '../../../../types';

export const RatingWrapper = styled<any, Theme>('header')`
  display: flex;
  text-align: center;
  flex-direction: ${props => (props.view === 'default' ? 'row' : 'column')}
`;

export default styled<any, Theme>('section')`
  color: ${props => props.theme.review[props.template].ratingColor};
  font-weight: ${BOLD};
  font-size: ${props => (props.view === 'default' ? '1.75rem' : '2.75rem')};
  margin-right: ${props => (props.view === 'default' ? '1rem' : '0')};

  span {
    font-size: ${props => props.theme.review.rating.fontSize};
  }
`;
